import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';

import { initChunkRecovery } from '@shared/chunks';

import { getConfig, setConfig } from 'pkg/config/app';

import { lockOrientation } from 'pkg/app/orientation';
import * as logger from 'pkg/logger';
import { syncAppleMeta } from 'pkg/meta_tags';
import { isApp, isIOS } from 'pkg/platform';
import { pushState } from 'pkg/router/state';

import { initDeepLinks, markAppRendered } from 'components/DeepLinkObserver';

import { keepPreviewId } from 'components/announcements/preview';

import 'css/global.css';
import 'pkg/core/sdk';
import 'pkg/dev/generateRouteDocs';

setConfig(window.TS);
keepPreviewId();

if (isApp()) {
	document.documentElement.dataset.app = '';
}

initChunkRecovery(() => getConfig().version);

window.handleOpenURL = (url: string) => {
	//incoming url includes custom-url-scheme.
	const [protocol, location] = url.split('://');

	// handleOpenURL also receives all calls to window.open, leading to external links being pushed to the state.
	if (!protocol.startsWith('threesixty')) {
		return;
	}

	pushState(location);
};

async function init() {
	if (isApp()) {
		SplashScreen.hide();
		await lockOrientation();

		await initDeepLinks();
	}

	const { storageUrl } = getConfig();
	if (!isApp() && storageUrl) {
		navigator.serviceWorker?.register(
			`/attachment-cache.js?storage=${encodeURIComponent(storageUrl)}`
		);
	}

	if (isIOS()) {
		Keyboard.setAccessoryBarVisible({ isVisible: true });
	}

	logger.init();

	syncAppleMeta(location.pathname + location.search + location.hash);

	window.addEventListener('statusTap', function () {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	});

	if (EASYAUTH_DEV_BUILD && getConfig().easyAuthDev) {
		const easyAuthDev = await import('pkg/auth/easyauth_dev');
		await easyAuthDev.ensureSession();
	}

	const render = await import(/* webpackPreload: true */ './render');
	render.renderApp();
	markAppRendered();
}

document.addEventListener(isApp() ? 'deviceready' : 'DOMContentLoaded', init);
